import styled from 'styled-components'
import { media } from 'utils/media'
import { Text, textSize } from 'lib/Text'

export const ContentBoxTitle = styled(Text).attrs({ as: 'h2', weight: 'semi', size: 'l' })`
  align-items: center;
  display: flex;
  flex-grow: 1;
  justify-content: flex-start;
  min-height: 52px;
  ${media.phoneDown} {
    ${textSize('m')}
  }
`
